import type { AppDispatch } from 'store';

import { firebaseAuth } from 'lib/firebase/firebase.client';
import { actions as teamActions } from 'store/team';

export const teamMiddlewareOnUserUpdate = async (dispatch: AppDispatch) => {
  if (!firebaseAuth.currentUser) return;
  const idToken = await firebaseAuth.currentUser!.getIdToken();

  const res: $TSFixMe = await fetch(`/api/team`, {
    method: 'GET',
    cache: 'no-cache',
    headers: { Authorization: `Bearer ${idToken}`, 'Content-Type': 'application/json' }
  });
  if (res.status === 200) {
    const team = await res.json();
    if (team?.success) {
      dispatch(teamActions.set(team));
    } else {
      dispatch(teamActions.clear());
    }
  } else {
    dispatch(teamActions.clear());
  }
};
